import { Env } from '../../../env';
import { ApiClient } from '../../../http/api_client';
import { SoloareDeliveryUpdateResponse } from '../../../models/currentsystem/soloare/soloare_delivery_update_response';

export class DeliveryUpdateRepository {
    async updateDelivery(
        datetime: Date | null,
        ajaxParam0: String | null
    ): Promise<SoloareDeliveryUpdateResponse> {
        const updateResult = await ApiClient.get(
            Env.SETTING.userPublicApi.urlBase +
            "buyer/view/header/teeda.ajax?component=header_changeDlivCdPage&action=ajaxChangeDliv" +
            "&time=" + datetime + "&AjaxParam0=" + ajaxParam0 + "&0=" + ajaxParam0
        );
        return new SoloareDeliveryUpdateResponse(updateResult.result);
    }
}
